import {
   postRequest,
} from "@/utils/api";

// 查询推送日志列表
export function listPushLog(params) {
   return postRequest('/api/coo/push/log/list', params)
}

// 查询推送日志详情
export function getPushLogDetail(id) {
   return postRequest('/api/coo/push/log/detail', { id })
}

// 重新推送
export function retryPush(id) {
   return postRequest('/api/coo/push/log/retry', { id })
}
